import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/company',
        name: 'company',
		subheader: languages.company.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "21",
            icon: "team",
        },
        component: PageAll,
		children: [
			{
				path: '/company',
				name: 'company-list',
				component: resolve => require(['@/pages/company/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.company.title1,
					permCode: "2101",
				},
			}
		]
    },
]
